import * as React from 'react';

type Stat = {
    stat: string;
    title: string;
};

interface BenefitsListItemProps {
    stats: Stat[];
}

const AudienceStatListItem = (props: BenefitsListItemProps) => {
    const { stats } = props;

    return (
        <>
            {stats.map((stat, idx) => (
                <div
                    key={idx}
                    className="flex flex-col justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-2 px-5 py-4"
                >
                    <p className="flex-grow-0 flex-shrink-0 text-3xl text-[#5637cd]">{stat.stat}</p>
                    <p className="self-stretch flex-grow-0 flex-shrink-0 text-xl text-[#110b29] text-center">
                        {stat.title}
                    </p>
                </div>
            ))}
        </>
    );
};

export default AudienceStatListItem;
